import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../../firebase';
import './CircleEventList.css';

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('ja-JP', { month: 'short', day: 'numeric' });
}

const STATUS_LABELS = { recruiting: '募集中', closed: '受付終了', cancelled: 'キャンセル' };

function CircleEventList({ circleId, isOwner, maxItems = 5 }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!circleId) return;
    let active = true;
    setLoading(true);

    getDocs(query(
      collection(db, 'recruitments', circleId, 'events'),
      where('status', 'in', ['recruiting', 'closed']),
      orderBy('date', 'asc'),
      limit(maxItems),
    ))
      .then((snap) => {
        if (!active) return;
        setEvents(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      })
      .catch((err) => console.error('CircleEventList fetch failed:', err))
      .finally(() => { if (active) setLoading(false); });

    return () => { active = false; };
  }, [circleId, maxItems]);

  if (loading) return <p className="cel-loading">読み込み中...</p>;

  return (
    <div className="cel-container">
      {isOwner && (
        <div className="cel-header">
          <Link to={`/circles/${circleId}/events/new`} className="cel-new-btn">
            + イベントを作成
          </Link>
        </div>
      )}

      {events.length === 0 ? (
        <p className="cel-empty">
          {isOwner ? 'まだイベントがありません。山行計画を投稿してメンバーを集めましょう。' : 'まだイベントがありません。'}
        </p>
      ) : (
        <ul className="cel-list">
          {events.map((ev) => (
            <li key={ev.id}>
              <Link to={`/circles/${circleId}/events/${ev.id}`} className="cel-item">
                <div className="cel-item__date">{formatDate(ev.date)}</div>
                <div className="cel-item__body">
                  <p className="cel-item__title">{ev.title || ev.mountain}</p>
                  <p className="cel-item__sub">
                    {ev.mountain && ev.title && `${ev.mountain} · `}
                    {ev.capacity > 0 ? `${ev.participantCount || 0}/${ev.capacity}人` : `${ev.participantCount || 0}人参加`}
                  </p>
                </div>
                <span className={`cel-status cel-status--${ev.status}`}>
                  {STATUS_LABELS[ev.status] || ev.status}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CircleEventList;
